// src/components/Navbar.jsx
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function Navbar() {
    const { isAuthed, userEmail, logout } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();

    function onLogout() {
        logout();
        nav("/login", { replace: true });
    }

    const isActive = (path) => loc.pathname.startsWith(path);

    return (
        <div style={styles.bar}>
            <div style={styles.left}>
                <div style={styles.brand}>drovis-saas-web</div>
                <Link style={{ ...styles.link, ...(isActive("/upload") ? styles.active : {}) }} to="/upload">
                    Upload
                </Link>
                <Link style={{ ...styles.link, ...(isActive("/jobs") ? styles.active : {}) }} to="/jobs">
                    Jobs
                </Link>
            </div>

            <div style={styles.right}>
                {isAuthed ? (
                    <>
                        <span style={styles.email}>{userEmail}</span>
                        <button style={styles.btn} onClick={onLogout}>Logout</button>
                    </>
                ) : null}
            </div>
        </div>
    );
}

const styles = {
    bar: {
        height: 56,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 16px",
        borderBottom: "1px solid #e5e7eb",
        background: "#fff",
    },
    left: { display: "flex", alignItems: "center", gap: 14 },
    right: { display: "flex", alignItems: "center", gap: 12 },
    brand: { fontWeight: 900, marginRight: 10 },
    link: { textDecoration: "none", color: "#111827", padding: "6px 10px", borderRadius: 10 },
    active: { background: "#111827", color: "#fff" },
    email: { color: "#6b7280", fontSize: 13 },
    btn: { border: "1px solid #e5e7eb", background: "#fff", borderRadius: 10, padding: "6px 10px", cursor: "pointer" },
};
